import React from 'react';
import './Renovation.css';

const Renovation: React.FC = () => {
  return (
    <div className="renovation-root">
      <div className="renovation-overlay">
        <h1>Website is Under Renovation</h1>
        <p>We're improving the site. Please check back soon.</p>
        {/* <a className="renovation-link" href="/home">Go to Home (developer)</a> */}
      </div>
    </div>
  );
};

export default Renovation;
